import { css } from '@emotion/css';

// 지도 SDK에 넘기는 DOM 마커에 className으로 지정하므로 클래스 문자열로 정의한다.
export const marker = css`
    align-items: center;
    background-color: var(--color-gray6);
    border-radius: 15px;
    color: var(--color-white);
    column-gap: 4px;
    display: flex;
    font-size: 14px;
    font-weight: bold;
    height: 32px;
    line-height: 20px;
    padding: 0 10px;
`;

export const cluster = css`
    align-items: center;
    background: rgba(110, 104, 100, 0.8);
    border-radius: 50%;
    color: var(--color-white);
    cursor: pointer;
    display: flex;
    font-size: 14px;
    font-weight: bold;
    justify-content: center;
`;

export const location = css`
    align-items: center;
    display: flex;
    flex-direction: column;
    row-gap: 4px;
`;

export const locationText = css`
    background-color: #121212;
    border-radius: 4px;
    color: var(--color-white);
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    padding: 2px 8px;
`;
